module.exports = __webpack_public_path__ + "assets/img/main-logo_mobile-baoding.03145478.png";